import { Box, Center, Flex, Image, Text } from "@chakra-ui/react";
import CompanyInfo from "components/CompanyInfo";
import usePathNavigate from "lib/hook/usePathNavigate";
import withAuth from "lib/hook/withAuth";
import { convertDateReservation } from "lib/utils/regular";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const PaymentResult = () => {
    const { pathNavigate } = usePathNavigate();
    const location = useLocation();

    const [pickupDate, setPickupDate] = useState("");
    const [orderId, setOrderId] = useState("");

    const [deliveryTextMain, setDeliveryTextMain] =
        useState("제품을 포장하여 발송해 주세요");
    const [deliveryTextSub, setDeliveryTextSub] = useState(
        `알림톡으로 제공된 주소로 제품을 발송하신 후\n'운송장 등록' 버튼을 눌러 발송 정보를 등록해 주세요.`
    );

    const onClickCompleted = () => {
        pathNavigate("/", { replace: true });
    };

    const setDeliveryText = (method: string) => {
        // 픽업/배송방식,  0 버틀러, 1 택배, 2 매장, 3 택배요청
        switch (method) {
            case "0":
                setDeliveryTextMain(
                    convertDateReservation(Number.parseInt(pickupDate!))
                );
                setDeliveryTextSub(
                    `민트 버틀러가 요청하신 픽업 일시에 방문 예정입니다.`
                );
                break;
            case "3":
                setDeliveryTextMain("제품을 안전하게 포장해 주세요");
                setDeliveryTextSub(
                    `택배원이 고객님의 소중한 제품 픽업을 위해 \n영업일 기준 1~2일 이내에 방문 드릴 예정입니다.`
                );
                break;
            case "1":
            case "2":
            default:
                setDeliveryTextMain("제품을 포장하여 발송해 주세요");
                setDeliveryTextSub(
                    `알림톡으로 제공된 주소로 제품을 발송하신 후\n'운송장 등록' 버튼을 눌러 발송 정보를 등록해 주세요.`
                );
                break;
        }
    };

    useEffect(() => {
        const query = queryString.parse(location.search);
        const { delivery_method, reservation_date, order_id } = query as {
            delivery_method: string;
            reservation_date: string;
            order_id: string;
        };

        setDeliveryText(delivery_method);
        setPickupDate(reservation_date);
        setOrderId(order_id);
    }, []);

    return (
        <Flex h="100%" position={"relative"} flexDirection="column">
            <Flex
                flexDirection="column"
                mx="20px"
                flex={1}
                justifyContent={"center"}
            >
                <Center mb="1rem">
                    <Image src="/assets/images/icn_circle_check.svg" />
                </Center>
                <Text
                    fontSize={"1.375rem"}
                    fontWeight="semibold"
                    mb="0.25rem"
                    align={"center"}
                >
                    주문이 완료되었습니다.
                </Text>

                <Box>
                    <Text
                        fontSize={"1.375rem"}
                        fontWeight="semibold"
                        color="mint.500"
                        mb="0.75rem"
                        align={"center"}
                    >
                        {deliveryTextMain}
                    </Text>
                    <Center>
                        <Text
                            fontSize={"0.875rem"}
                            fontWeight="semibold"
                            align={"center"}
                            whiteSpace="pre"
                        >
                            {deliveryTextSub}
                        </Text>
                    </Center>
                </Box>
                <Center
                    w="100%"
                    h="50px"
                    mt="2.5rem"
                    bgColor={"mint.500"}
                    borderRadius="md"
                    fontSize={"1rem"}
                    fontWeight="semibold"
                    color={"white"}
                    onClick={onClickCompleted}
                >
                    확인
                </Center>
            </Flex>

            <CompanyInfo />
        </Flex>
    );
};

export default withAuth(PaymentResult);
